export const getStartAndEndPoints = (
  xMin,
  xMax,
  yMin,
  yMax,
  oneMeter,
  roomLeftOnXAxis,
  roomLeftOnYAxis
) => {
  const roomToEachSideOnXAxis =
    roomLeftOnXAxis > 0 ? (roomLeftOnXAxis * oneMeter) / 2 : 0;
  const roomToEachSideOnYAxis =
    roomLeftOnYAxis > 0 ? (roomLeftOnYAxis * oneMeter) / 2 : 0;

  const horizontalLinesStart = [
    xMin,
    yMin + 0.5 * oneMeter + roomToEachSideOnYAxis,
    xMax,
    yMin + 0.5 * oneMeter + roomToEachSideOnYAxis,
  ];
  const verticalLinesStart = [
    xMin + 0.5 * oneMeter + roomToEachSideOnXAxis,
    yMin,
    xMin + 0.5 * oneMeter + roomToEachSideOnXAxis,
    yMax,
  ];

  return {
    horizontalStart: horizontalLinesStart,
    verticalStart: verticalLinesStart,
  };
};

export const calculateRectangleProperties = (roomCorners, length) => {
  const xCoordinates = roomCorners.filter(
    (value, index) => (index + 1) % 2 !== 0
  );

  const yCoordinates = roomCorners.filter(
    (value, index) => (index + 1) % 2 === 0
  );

  const xMin = Math.min(...xCoordinates);
  const yMin = Math.min(...yCoordinates);

  const xMax = Math.max(...xCoordinates);
  const yMax = Math.max(...yCoordinates);

  const oneMeter = Math.max(xMax - xMin, yMax - yMin) / length;

  const roomWidth = Math.min(xMax - xMin, yMax - yMin) / oneMeter;

  return {
    xMin,
    yMin,
    xMax,
    yMax,
    height: yMax - yMin,
    width: xMax - xMin,
    shorterSideInMeters: roomWidth,
  };
};

const getParallelLine = (line, pixelsInMeter, clockwise, distanceFromWall) => {
  const [x1, y1, x2, y2] = line;
  const dx = x2 - x1;
  const dy = y2 - y1;
  const length = Math.sqrt(dx ** 2 + dy ** 2);
  const udx = dx / length;
  const udy = dy / length;
  let nx, ny;
  if (clockwise) {
    nx = x1 - udy * pixelsInMeter * distanceFromWall;
    ny = y1 + udx * pixelsInMeter * distanceFromWall;
  } else {
    nx = x1 + udy * pixelsInMeter * distanceFromWall;
    ny = y1 - udx * pixelsInMeter * distanceFromWall;
  }
  const sx = nx + dx;
  const sy = ny + dy;
  return [nx, ny, sx, sy];
};

export const getParallelWalls = (
  roomCorners,
  pixelsInMeter,
  clockwise,
  distanceFromWall
) =>
  getRoomSides(roomCorners).map((side) =>
    getParallelLine(side, pixelsInMeter, clockwise, distanceFromWall)
  );

export const getRoomSides = (roomCorners) => {
  const roomSides = [];

  for (let i = 0; i < roomCorners.length; i = i + 2) {
    if (i === roomCorners.length - 2) {
      roomSides.push([
        ...roomCorners.slice(i, i + 2),
        ...roomCorners.slice(0, 2),
      ]);
    } else {
      roomSides.push([...roomCorners.slice(i, i + 4)]);
    }
  }
  return roomSides;
};

export const calcPolygonArea = (vertices) => {
  let total = 0;
  for (let i = 0, l = vertices.length; i < l; i++) {
    const addX = vertices[i].x;
    const addY = vertices[i == vertices.length - 1 ? 0 : i + 1].y;
    const subX = vertices[i == vertices.length - 1 ? 0 : i + 1].x;
    const subY = vertices[i].y;

    total += addX * addY * 0.5;
    total -= subX * subY * 0.5;
  }

  return Math.abs(total);
};
